import PropTypes from "prop-types";

export default {
  children: PropTypes.node
};
